import { render, staticRenderFns } from "./indexImg.vue?vue&type=template&id=14d1a07d&"
import script from "./indexImg.vue?vue&type=script&lang=js&"
export * from "./indexImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports